import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import PopupContent from './PopupContent';
import ButtonAction from '../ButtonAction';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ModalContent from '../ModalContent';
import ModalButtonsContainer from '../ModalButtonsContainer';
import {buttonCancel, largeButtonsPadding} from '../../styles/styles';

interface PopupEditDocProps {
  docName: string,
  file: Blob | File | string,
  onSave: (file: Blob) => void,
  updateFileList: () => void,
}

const PopupEditDoc = (props: PopupEditDocProps) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => {
    setShow(false);
    props.updateFileList();
  };
  const handleShowModal = () => setShow(true);

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        label={<img src={'../../../media/common/Word.svg'} alt={'file'} className={'w-20px ml-1'}/>}
        onClick={handleShowModal}
        disabled={false}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'xxl'}>
        <>
          <ModalHeader
            type={'complex'}
            header={<FormattedMessage
              id="tab-order-documents-editDoc-header"
              defaultMessage="Edit document"
              values={{name: props?.docName || ''}}/>
            }
            icon={'../../../media/common/Edit_primary.svg'}
          />
          <ModalContent>
            <PopupContent {...props}/>
          </ModalContent>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              onClick={handleCloseModal}
              label={<FormattedMessage id="button-cancel" defaultMessage="Cancel"/>}
              disabled={false}
              customClassnames={buttonCancel}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupEditDoc;
